export const orgAccountStatuses = ['cancelled'] as const
export type OrgAccountStatus = typeof orgAccountStatuses[number]

export type AnalyticsOrgAccountStatus = 'Cancelled' | 'On trial' | 'Trial expired' | 'Paying customer'

/** Derives an org's Mixpanel `Account status` from its stored status, tier and trial end date. */
export function getOrgAccountStatus(org: { accountStatus?: OrgAccountStatus; tierName?: string; trialEndDate?: string }): AnalyticsOrgAccountStatus {
   if (org.accountStatus === 'cancelled') return 'Cancelled'
   if (org.tierName === 'Trial') {
      const trialHasEnded = !!org.trialEndDate && new Date(org.trialEndDate).getTime() < Date.now()
      return trialHasEnded ? 'Trial expired' : 'On trial'
   }
   return 'Paying customer'
}
